import * as Yup from 'yup'

export const initialEditFormValues = (values) => {
    return {
        group_id: values.group_id || "",
        group_name: values.group_name || "",
        discount_value: values.discount_value || "",
        discount_percent: values.discount_percent || "",
        active: values.active || "",
    }
}

export const editFormValidationSchema = Yup.object({
    group_name: Yup.string().required('This field is required'),
    discount_value: Yup.string(),
    discount_percent: Yup.string(),
    active: Yup.string(),
})